/* eslint-disable no-underscore-dangle */
/* eslint-disable no-var */
import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { DeployParams } from 'src/app/deployParams';
import { SiteViewConfiguration, PlatformHeadrId } from 'src/app/models/enums';
import { EventsService } from 'src/app/services/events.service';
import { environment } from 'src/environments/environment';

declare var SIR: any;
declare var $: any;

@Component({
  selector: 'app-match-preview-widget',
  templateUrl: './match-preview-widget.component.html',
  styleUrls: ['./match-preview-widget.component.less'],
})
export class MatchPreviewWidgetComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private language: string;
  private _betRadarEventId: number;
  private widgetLanguage: string;
  clientId = '92628c1eaee83871af5e17444ec08c99';

  // @Input()
  // betRadarEventId: number;

  @Input()
  set betRadarEventId(value: number) {
    if (this._betRadarEventId !== undefined) {
      this._betRadarEventId = value;
      this.setMatchIdOnWidget();
    } else {
      this._betRadarEventId = value;
    }
  }

  constructor(private eventsService: EventsService) {}
  ngAfterViewInit() {
    // setTimeout(() => {
    //   // console.log('kreno');
    //   const interval = setInterval(() => { this.setWidget(interval); }, 300);
    // }, 500);
  }

  ngOnInit(): void {
    this.setMatchIdOnWidget();
  }

  setMatchIdOnWidget() {
    // console.log(this._betRadarEventId);
    SIR('addWidget', '.sr-widget', 'match.preview', {
      disableMoreStats: true,
      disableExpandButton: true,
      matchId: this._betRadarEventId,
    });

    setTimeout(() => {
      // console.log('test');
      const interval = setInterval(() => {
        this.setDialogPosition(interval);
      }, 100);
    }, 200);
  }

  expandH2widget(interval1) {
    if (!document.querySelector('.sr-hth-button__button')) {
      return;
    }
    clearInterval(interval1);
    $('.sr-hth-button__button').click();
    // $('.srm-fullyloaded').css('opacity', 0);
    // $('.sr-hth-button__button').css('width', 0);
    // $('.sr-hth-button__label').css('width', 0);
    // $('.sr-hth-button__close').hide();
  }

  setDialogPosition(interval) {
    if (
      !document.querySelector(
        '.sr-widget .srm-fullyloaded .sr-matchpreview-other'
      )
    ) {
      return;
    }

    if (document.getElementById('matchPreviewWrap') === null) {
      return;
    }
    const matchPreviewWrap = document.getElementById('matchPreviewWrap');
    let scrollTop = 0;
    const windowHeight = window.parent.innerHeight;
    const documentHeight = document.body.clientHeight;

    // set max height on dialog
    if (windowHeight < documentHeight) {
      matchPreviewWrap.style.maxHeight = windowHeight - 30 + 'px';
    } else {
      matchPreviewWrap.style.maxHeight = documentHeight - 30 + 'px';
    }

    // set scroll not to be over footer
    if (windowHeight + scrollTop > documentHeight) {
      window.parent.scroll(0, documentHeight - windowHeight);
      scrollTop = documentHeight - windowHeight;

      if (scrollTop < 0) {
        scrollTop = 0;
      }
    }

    setTimeout(() => {
      // position dialog
      if (scrollTop + windowHeight - 30 < documentHeight) {
        const move =
          scrollTop + (windowHeight - matchPreviewWrap.offsetHeight) / 2;
        // console.log(move);
        matchPreviewWrap.style.transform = 'translate(0px, ' + move + 'px)';
      } else {
        const move =
          scrollTop + (documentHeight - matchPreviewWrap.offsetHeight) / 2;
        // console.log(move);
        matchPreviewWrap.style.transform = 'translate(0px, ' + move + 'px)';
        // const move = documentHeight - windowHeight;
        // matchPreviewWrap.style.transform = 'translate(0px, 15px)';
      }

      setTimeout(() => {
        // console.log('ussoo');
        matchPreviewWrap.style.opacity = '1';
        // matchPreviewWrap.style.transition = 'none';

        // this.disableParentScroll();
      }, 100);
    }, 400);

    clearInterval(interval);
  }

  closeWidget() {
    this.eventsService.openCloseMatchPreviewWidget();
  }

  disableParentScroll() {
    window.parent.document.documentElement.style.overflow = 'hidden';
  }

  ngOnDestroy(): void {
    // setTimeout(() => {
    // window['SIR']('removeWidget', '.sr-widget');
    SIR('removeWidget', document.querySelector('.sr-widget'));
    setTimeout(() => {
      SIR('check');
    }, 500);
    // },100);
  }
}
